import * as yup from "yup";

import { Button, Typography } from "@mui/material";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { format, parse } from "date-fns";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import DataPicker from "../../../../components/hookForms/datePicker";
import IconButton from "@mui/material/IconButton";
import { Loader } from "./styles";
import messages from "../../../../utils/messages";
import serviceSincronizacao from "../../../../services/serviceSincronizacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import serviceClienteInstalacao from "../../../../services/serviceClienteInstalacao";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function DialogSync({ open, onClose }: IDialogProps) {
    const [syncData, setSyncData] = useState("");
    const [status, setStatus] = useState("");
    const [isDisable, setIsDisable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    let timer: any;

    const updateStatus = () => {
        timer =
            !timer &&
            setInterval(() => {
                if (status === "Em execução") {
                    refreshStatus();
                    return;
                }
            }, 5000);
    };

    const validationSchema = yup.object().shape({
        updateDate: yup.string().required(messages.requiredField).typeError(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            status: "",
            entidadeAtual: "",
            dataUltimaSincronizacao: "",
            updateDate: { syncData },
        },
    });

    const refreshStatus = async () => {
        const response = await serviceClienteInstalacao.getStatusSincronizacao();
        const resStatus = response?.data?.status || "";
        setStatus(response?.data?.status);
        setIsDisable(resStatus === "Em execução");

        if (response?.data?.dataUltimaSincronizacao) {
            const formatDate = parse(response?.data?.dataUltimaSincronizacao, "dd/MM/yyyy HH:mm:ss", new Date());
            setSyncData(format(formatDate, "dd/MM/yyyy HH:mm:ss"));
        }
    };

    useEffect(() => {
        if(open){
            refreshStatus();
        }
    }, [open]);

    useEffect(() => {
        refreshStatus();
    }, [status]);

    useEffect(() => {
        updateStatus();
        return () => clearInterval(timer);
    }, [status]);

    const synchronizeAsync = async (data: any) => {
        serviceSincronizacao
            .Synchronize({ ...data })
            .then((result) => {
                if (result) {
                    toast.success("Sincronização realizada com sucesso");
                }
            })
            .catch((err) => {
                toast.error("Ocorreu um erro ao realizar a sincronização", err);
            });
    };

    const onSubmit = (values: any) => {
        setStatus("Em execução");
        const updateDate = new Date(values.updateDate);

        setIsDisable(true);
        const data = {
            ...values,
            updateDate: values.updateDate ? format(updateDate, "dd/MM/yyyy") : "",
        };

        synchronizeAsync(data);
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Sincronizar
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {status === "Em execução" && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Typography variant="h6">Status: {status || "Carregando..."}</Typography>
                            <Typography variant="h6">Data da última sincronização: {syncData}</Typography>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <DataPicker
                                name="updateDate"
                                label="Data para atualização"
                                control={control}
                                error={errors}
                                disabled={isDisable}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
